import React from 'react';
import { Theme, TextField } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import createStyles from '@mui/styles/createStyles';
import useShopFormat from 'hooks/useShopFormat';

export interface Props {
	date: string;
	label: string;
}

const DeliveryTimeDetails = (props: Props) => {
	const { date, label } = props;
	const classes = useStyles();
	const { localFormat } = useShopFormat();
	return (
		<TextField
			value={localFormat(date, 'ddd. MMM D, HH:mm')}
			variant="standard"
			label={label}
			InputProps={{
				readOnly: true,
				disableUnderline: true,
				classes: {
					input: classes.input,
				},
			}}
			InputLabelProps={{
				classes: { root: classes.labelRoot },
			}}
		/>
	);
};

const useStyles = makeStyles((theme: Theme) =>
	createStyles({
		input: {
			fontSize: '1.3rem',
		},
		labelRoot: {
			width: 164,
		},
	}),
);

export default DeliveryTimeDetails;
